import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';

export const CTASection = ({ 
  headline = "Reserve Your Summer Storage Today",
  subtext = "Book your storage before finals week and schedule your pickup during move-out.",
  primaryBtnText = "Reserve Storage Now",
  secondaryBtnText = "Get Started",
  secondaryLink = "/how-it-works",
  showSecondaryBtn = true,
  variant = "default" 
}) => {
  const bgClass = variant === "light" 
    ? "bg-surface" 
    : "bg-navy";
  
  const textClass = variant === "light"
    ? "text-navy"
    : "text-white";

  return (
    <section 
      className={`${bgClass} section-padding`}
      data-testid="cta-section"
    >
      <div className="section-container">
        <motion.div 
          className="text-center max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 
            className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-6 ${textClass}`}
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {headline}
          </h2>
          <p className={`text-lg md:text-xl mb-8 ${variant === "light" ? "text-gray-600" : "text-gray-300"}`}>
            {subtext}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button 
                className="btn-primary text-base px-8 py-4"
                data-testid="cta-primary-btn"
              >
                <Calendar className="w-5 h-5 mr-2" />
                {primaryBtnText}
              </Button>
            </Link>
            
            {showSecondaryBtn && (
              <Link to={secondaryLink}>
                <Button 
                  className={variant === "light" 
                    ? "btn-outline text-base px-8 py-4" 
                    : "btn-outline-white text-base px-8 py-4"
                  }
                  data-testid="cta-secondary-btn"
                >
                  {secondaryBtnText}
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
